import { Button } from '@material-ui/core';
import { useEffect } from 'react';
import { useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import en from '../../../lang/en-us';
import TextInput from '../../../lib/TextField';
import { UploadFile } from '../../../lib/UploadFile.tsx';
import { RootStateType } from '../../../redux-store/reducers';
import { PAN_FOLIO_DATA, REQUESTBODY } from './update-pan-list';
import { sendPhoneOTP, updatePreLoginPan } from '../../../redux-store/actions/nct';
import { OTP_ACTIONS, panRegex } from '../../../utils/constants';
import { ActionHeader } from '../../dashboard/makeNct';
import { getRandomItem, NOT_VERIFIED } from '../../common/utils';
import { KYCCheck } from '../../common/KYCCheck';
import { checkKYC } from '../../../redux-store/actions/newPurchase';
import { useHistory } from 'react-router';
import {
    GET_KYC_VERIFIED,
    IsAllow,
    SET_KYC_REGISTRATION_POPUP,
} from '../../../redux-store/types/portfolio';
const { dashboard, common } = en;

function UpdatePanSelected(props: any) {
    const { reqId, otpRef, isEmail = false, userInfo } = props.location.state || {};
    const [selectedFunds, setSelected] = useState<PAN_FOLIO_DATA[]>([]);
    const [newPan, setPan] = useState<string>('');
    const [panError, setPanError] = useState<string>('');
    const { kycVerified, loading } = useSelector(({ newPurchase }: RootStateType) => ({
        kycVerified: newPurchase.kycVerified,
        loading: newPurchase.apiPendingActions.includes(GET_KYC_VERIFIED),
    }));
    const [showDialog, setShowDialog] = useState(false);
    const [cheques, setCheques] = useState<any>({
        pan: { name: 'PAN', format: '', content: '' },
    });
    const dispatch = useDispatch();
    const history = useHistory();
    const randomFund: any = getRandomItem(props.location.state.targetFunds);

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
        }
        const { targetFunds } = props.location.state || {};
        setSelected(targetFunds);
    }, []);

    const handleSubmit = async () => {
        const { targetFunds } = props.location.state || {};
        const data = targetFunds.map((_ele: PAN_FOLIO_DATA) => ({
            amc: _ele.fund || _ele.amc,
            folio: _ele.folio,
            newPan: newPan.toUpperCase(),
        }));

        try {
            let isKYCVerified = kycVerified.value === IsAllow.YES;
            let kycMessage = kycVerified.message || '';
            if (newPan.toUpperCase().match(panRegex)) {
                if (
                    kycVerified.value === null ||
                    kycVerified.lastUsedPan !== newPan.toUpperCase()
                ) {
                    let { body }: any = await dispatch(
                        checkKYC({
                            jh1Pan: '',
                            jh2Pan: '',
                            amc: '',
                            pan: newPan,
                            reqId: '12345',
                        }),
                    );
                    isKYCVerified = body.success.panStatus.toUpperCase() === 'VERIFIED';
                    kycMessage = body.success.panStatus;
                }
                if (isKYCVerified) {
                    let requestBody: any = {
                        pekrn: '',
                        reqId,
                        mobile: !isEmail ? userInfo : '',
                        email: isEmail ? userInfo : '',
                    };
                    let response = await props.updatePreLoginPan({
                        data,
                        images: [cheques.pan],
                        action: OTP_ACTIONS.PRELOGIN_UPDATE_PAN,
                        ...requestBody,
                    });
                    props.history.replace('update-pan-success', { data, ...(response || {}).body });
                } else {
                    setShowDialog(true);
                } 
            } else {
                setPanError(common.errors.pan.individualPan);
            }
        } catch (err: any) {
            alert(err.message);
        }
    };
    console.log(randomFund, 'rf');
    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.UpdatePan.UpdatePanHeading} />
            <KYCCheck
                callApi={showDialog}
                allowRegistration={{
                    isin: randomFund.id,
                    amc: randomFund.fund,
                }}
            />
            <div className="curved-bg-content update-pan-selected-content">
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <p>{dashboard.UpdatePan.selectedFolios.subheading}</p>
                        {selectedFunds.map((_ele: PAN_FOLIO_DATA, ind: number) => (
                            <div className="selected-folios-list">
                                <h3>{_ele.amcName}</h3>
                                <a
                                    className="delete-folio"
                                    // href="#"
                                    onClick={() =>
                                        setSelected(
                                            selectedFunds.filter(
                                                (_ele: PAN_FOLIO_DATA, index: number) =>
                                                    index !== ind,
                                            ),
                                        )
                                    }
                                >
                                    <img src="/images/delete-folio.svg" alt="delete icon" />
                                </a>
                                <div className="selected-folios-list-bottom">
                                    <p>
                                        {dashboard.UpdatePan.selectedFolios.primaryHolder}
                                        <span>{_ele.firstHolderName}</span>
                                    </p>
                                    <p>
                                        {dashboard.UpdatePan.selectedFolios.contactNo}
                                        <span>{_ele.mobile}</span>
                                    </p>
                                    <p>
                                        {dashboard.UpdatePan.selectedFolios.pan}
                                        <span>{_ele.pan}</span>
                                    </p>
                                    <p>
                                        {dashboard.UpdatePan.selectedFolios.folioNo}
                                        <span>{_ele.folio}</span>
                                    </p>
                                </div>
                            </div>
                        ))}
                        {/* {selectedFunds.length < 3 && (
                            <div className="selected-folios-list add-folio">
                                <a
                                    // href="update-pan-list"
                                    onClick={() =>
                                        props.history.push('update-pan-list', {
                                            reqId,
                                            otpRef,
                                        })
                                    }
                                >
                                    <img src="/images/add-purple.svg" alt="icon" />{' '}
                                    {dashboard.UpdatePan.selectedFolios.addFolioText}{' '}
                                </a>
                            </div>
                        )} */}
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <h4 style={{ marginBottom: '-10px' }}>
                            {dashboard.UpdatePan.selectedFolios.enterPan}
                        </h4>
                        <div className="selected-folios-btn bank-selected-folios-bottom">
                            <div className="change-bank-upload">
                                <div className="change-bank-upload-inner">
                                    <div className="change-bank-upload-single">
                                        <p>{dashboard.UpdatePan.selectedFolios.enterPanInfo}</p>
                                        <div className="bank-selected-upload-fields">
                                            <TextInput
                                                variant="outlined"
                                                value={newPan.toUpperCase()}
                                                onChange={({ target: { value } }) => setPan(value)}
                                                error={!!panError}
                                                helperText={panError}
                                                onFocus={() => setPanError('')}
                                            />
                                        </div>
                                    </div>
                                    <div className="change-bank-upload-single">
                                        <p style={{ marginTop: 15 }}>
                                            {dashboard.UpdatePan.uploadPan}
                                        </p>
                                        <div className="bank-selected-upload-fields">
                                            <UploadFile
                                                onImageSelected={(value, format) => {
                                                    setCheques({
                                                        pan: {
                                                            ...cheques.pan,
                                                            format: format,
                                                            content: value,
                                                        },
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <Button
                                    onClick={() => {
                                        handleSubmit();
                                    }}
                                    className="customBtn"
                                    disabled={!newPan || !cheques.pan.content}
                                >
                                    {dashboard.UpdatePan.buttonText}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    sendPhoneOTP,
    updatePreLoginPan,
})(UpdatePanSelected);
